import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  () => ({
    iframe: {
      width: "100%",
      height: "100%",
      border: "none",
    },
    iframeHidden: {
      visibility: "hidden",
    },
    loader: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
      pointerEvents: "none",
      background: "rgba(255, 255, 255, 0.72)",
    },
  }),
  { name: "AppFrame" },
);
